import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { ApplicationArtatech } from './application-artatech.model';
import { ApplicationArtatechPopupService } from './application-artatech-popup.service';
import { ApplicationArtatechService } from './application-artatech.service';
import {LocalFile} from './application-artatech.model';
@Component( {
    selector: 'dcs-application-artatech-dialog',
    templateUrl: './application-artatech-dialog.component.html'
} )
export class ApplicationArtatechDialogComponent implements OnInit {

    application: ApplicationArtatech;
    authorities: any[];
    localFiles: ApplicationArtatech[];
    selected: ApplicationArtatech;
    isSaving: boolean;

    constructor(public activeModal: NgbActiveModal,
                private jhiLanguageService: JhiLanguageService,
                private alertService: AlertService,
                private applicationService: ApplicationArtatechService,
                private eventManager: EventManager) {
        this.jhiLanguageService.setLocations( [ 'application' ] );
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = [ 'ROLE_USER', 'ROLE_ADMIN' ];

        this.applicationService.findLocalFiles()
            .subscribe( (res: Response) => {
                this.localFiles = res.json();
                console.log(this.localFiles);
            } );
    }

    clear() {
        this.activeModal.dismiss( 'cancel' );
    }

    save() {
        this.isSaving = true;
        if (this.application.id !== undefined) {
            this.applicationService.update( this.application )
                .subscribe( (res: ApplicationArtatech) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
        } else {
            this.applicationService.create( this.application )
                .subscribe( (res: ApplicationArtatech) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
        }
    }

    onSelectLocal(event) {
        console.log(this.selected);
        this.application.downloadUrl = this.selected.downloadUrl;
        this.application.name = this.selected.name;
        this.application.packageName = this.selected.packageName;
    }

    private onSaveSuccess(result: ApplicationArtatech) {
        this.eventManager.broadcast( { name: 'applicationListModification', content: 'OK' } );
        this.isSaving = false;
        this.activeModal.dismiss( result );
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError( error );
    }

    private onError(error) {
        this.alertService.error( error.message, null, null );
    }
}

@Component( {
    selector: 'dcs-application-artatech-popup',
    template: ''
} )
export class ApplicationArtatechPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(private route: ActivatedRoute,
                private applicationPopupService: ApplicationArtatechPopupService) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe( params => {
            if (params[ 'id' ]) {
                this.modalRef = this.applicationPopupService
                    .open( ApplicationArtatechDialogComponent, params[ 'id' ] );
            } else {
                this.modalRef = this.applicationPopupService
                    .open( ApplicationArtatechDialogComponent );
            }

        } );
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech-dialog.component.ts